import React from "react";
import {Navigate} from "react-router-dom";
function TelemedicineRoomRoute({children}) {
    const patientLogin = localStorage.getItem("pat_login") === "true";
    const patientTokens = localStorage.getItem("patAuthTokens");
    const mainLogin = localStorage.getItem("user_login") === "true";
    const mainTokens = localStorage.getItem("authTokens");
    // ========================================================
    // PATIENT
    // ========================================================
    if (patientLogin && patientTokens) {
        return children;
    }
    // ========================================================
    // MAIN APPLICATION USER
    // ========================================================
    if (mainLogin && mainTokens) {
        return children;
    }
    // ========================================================
    // NOT LOGGED IN
    // ========================================================
    return (<Navigate
        to="/patient-login"
        replace
    />);
}
export default TelemedicineRoomRoute;